import React from "react";

export default function AutomStore() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.4721 9.20709L6.81557 7.56913L6.5935 6.11129C6.55747 5.87131 6.37747 5.67925 6.14348 5.61926L3.74338 5.0193C3.42542 4.93533 3.09542 5.1334 3.01732 5.45734C2.93937 5.77526 3.13143 6.10523 3.4554 6.18332L5.46549 6.68726L5.69344 8.19922L6.85142 15.8907L7.0554 17.2586C7.19349 18.1525 7.94351 18.8004 8.83755 18.8004H19.2002C19.5302 18.8004 19.8002 18.5304 19.8002 18.2004C19.8002 17.8704 19.5302 17.6005 19.2002 17.6005H8.83755C8.53754 17.6005 8.28546 17.3784 8.24356 17.0784L8.14163 16.4005H18.5999C19.926 16.4005 21 15.3266 21 14.0007V9.80098C21 9.49497 20.772 9.24309 20.472 9.20705L20.4721 9.20709Z"
                fill="#4F6E90"/>
            <path
                d="M9.59988 19.4001C8.60984 19.4001 7.7998 20.2101 7.7998 21.2C7.7998 22.19 8.60984 22.9999 9.59988 22.9999C10.5899 22.9999 11.4 22.19 11.4 21.2C11.4 20.2101 10.5899 19.4001 9.59988 19.4001Z"
                fill="#354F6C"/>
            <path
                d="M18.0003 19.4001C17.0102 19.4001 16.2002 20.2101 16.2002 21.2C16.2002 22.19 17.0102 22.9999 18.0003 22.9999C18.9903 22.9999 19.8003 22.19 19.8003 21.2C19.8003 20.2101 18.9903 19.4001 18.0003 19.4001Z"
                fill="#354F6C"/>
        </svg>
    );
}
